'use strict';

var AuthTokenRepository = require('redi-idp-web-token-lib').AuthTokenRepository;

module.exports = /* @ngInject */ function () {
  return {
    get: function () {
      return AuthTokenRepository.get();
    }
  };
};



//////////////////
// WEBPACK FOOTER
// /app/~/redi-idp-web-lib/dist/business/authTokenProvider.js
// module id = 112
// module chunks = 0